import { Select } from "antd";
import { observer } from "mobx-react-lite";
import { useIntl } from "react-intl";

type Props = {
  value?: string;
  onChange?: (value?: string) => void;
};

export const VerificationSelect = observer<Props>(({ value, onChange }) => {
  const intl = useIntl();
  return (
    <Select
      placeholder={intl.formatMessage({
        defaultMessage: "Select review status",
      })}
      options={[
        {
          label: intl.formatMessage({ defaultMessage: "Review" }),
          value: "review",
        },
        {
          label: intl.formatMessage({ defaultMessage: "Approved" }),
          value: "approved",
        },
        {
          label: intl.formatMessage({ defaultMessage: "Rejected" }),
          value: "rejected",
        },
      ]}
      value={value}
      onChange={onChange}
      onClear={onChange}
      allowClear
      style={{ width: "100%" }}
    />
  );
});
